import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const isChargedDeposit = async ({ phoneNumber, callerId }: { phoneNumber?: string; callerId?: string }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      phoneNumber,
      callerId,
    },
    query: graphql(`
      query IsChargedDeposit($phoneNumber: String, $callerId: String) {
        isChargedDeposit(phoneNumber: $phoneNumber, callerId: $callerId)
      }
    `),
  });

  return response.data?.isChargedDeposit ?? false;
};
